"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var Checkbox_1 = __importDefault(require("@material-ui/core/Checkbox"));
var HourglassEmptyTwoTone_1 = __importDefault(require("@material-ui/icons/HourglassEmptyTwoTone"));
var Check = function (props) {
    var _a = react_1["default"].useState(false), isLoading = _a[0], setLoading = _a[1];
    var x = props.x, y = props.y, data = props.data;
    var checked = !!data.find(function (r) { return r.x === x && r.y === y; });
    var handleClick = function () {
        props.onClick({ x: x, y: y, checked: checked }).then(function (resolved) {
            setLoading(false);
        });
        setLoading(true);
    };
    return (react_1["default"].createElement(TableCell_1["default"], { align: 'center' }, isLoading ? (react_1["default"].createElement(HourglassEmptyTwoTone_1["default"], null)) : (react_1["default"].createElement(Checkbox_1["default"], { color: 'primary', onClick: handleClick, checked: checked }))));
};
exports["default"] = Check;
